export const PLAYER_VIDEO_ID = 'player';
